<div class="oa-legend-sec">
    <div
        class="oa-legend-btn"
        #OALegendBtnProp
    ></div>
    <h1 class="oa-legend-list-header">
        {{ i18n._7496_COACHING_INDICATOR | translate }}
    </h1>
    <ul class="oa-legend-list">
        <li
            *ngFor="let currentGoal of oportunitiesArray; let i = index"
            class="oa-legend-list-items"
        >
            <goal-score [opportunity]="currentGoal"></goal-score>
            <div class="oa-legend-list-item-1">
                <p
                    class="oa-legend-list-item-1-1"
                    *ngIf="
                        currentGoal.view.oppType === opportunityType.COMPONENT
                    "
                >
                    {{ i18n._7497_NUMB_OF_COMPONENTS | translate }}
                </p>
                <p class="oa-legend-list-item-1-2">
                    {{
                        _opportunityTypeTranslationMap[currentGoal.view.oppType]
                            | translate
                    }}
                </p>
            </div>
        </li>
    </ul>
</div>
